import BlankBronze from '../Components/assets/images/blankBronze.png';
import BlankSilver from '../Components/assets/images/blankSilver.png';
import BlankGold from '../Components/assets/images/blankGold.png';
import { Option } from 'react-multi-select-component';

export const skills: Option[] = [
  { label: 'Mechanical', value: 'Mechanical' },
  { label: 'Electrical', value: 'Electrical' },
  { label: 'Plumbing', value: 'Plumbing' },
  { label: 'Others', value: 'Others' },
];

export const estimatedReason: any[] = [
  {
    value: "PC",
    label: "PC",
  },
  {
    value: "BC",
    label: "BC",
  },
  {
    value: "Revision",
    label: "Revision",
  },
  {
    value: "Initial Estimate",
    label: "Initial Estimate",
  },
  {
    value: "Internal Review",
    label: "Internal Review",
  },
  {
    value: "BC (xrefs)",
    label: "BC (xrefs)",
  },
  {
    value: "PS (xrefs)",
    label: "PS (xrefs)",
  },
  {
    value: "External Client Meeting",
    label: "External Client Meeting",
  },
  { value: 'rfiSubmittal', label: 'RFI/Submittal' },
  {
    value: "New Info",
    label: "New Info",
  },

]

export const caPhaseStatusOptions: { label: string; value: string }[] = [
  { label: 'Completed', value: 'Completed' },
  { label: 'Open', value: 'Open' }
];

export const caPhaseStampedAsOptions: { label: string; value: string }[] = [
  { label: 'Approved', value: 'Approved' },
  { label: 'As Noted', value: 'As Noted' },
  { label: 'Revise & Resubmit', value: 'Revise & Resubmit' },
  { label: 'Not Approved', value: 'Not Approved' },
  { label: 'None', value: 'None' }
];
export const categoryLevel: any = [
  {
    value: "project",
    label: "Project",
  },
  {
    value: "stage",
    label: "Stage",
  },
  {
    value: "task",
    label: "Task",
  },
  {
    value: "generalTimer",
    label: "General Timer",
  },
]
export const categoryTimer: any = [
  {
    value: "Project timer",
    label: "Project timer",
  },
  {
    value: "Stage timer",
    label: "Stage timer",
  },
  {
    value: "Task timer",
    label: "Task timer",
  },
  {
    value: "General timer",
    label: "General timer",
  },
]
export const promise: any = [
  {
    value: "Customer",
    label: "Customer",
  },
  {
    value: "Personal",
    label: "Personal",
  },
  {
    value: "hotPromise",
    label: "Hot Promise",
  },

]
export const projectStatuslist: string[] = [
  'On Hold',
  'Req Time Estimate',
  'In Progress',
  'IPR Ready To Deliver',
  'IPR In Progress',
  'IPR Pause',
  'Ready To Deliver',
  'Delivered',
  'IPR Todo'
]
export const taskStatuslist: string[] = [
  'On Hold', 'Draft',
  'IPR Ready To Deliver',
  'Internal Review',
  'Final Review',
  'Submit Internal Review',
  'Submit Final Review',
  'Todo Per Review',
  'Ready To Deliver',
  'In Progress',
  'IPR In Progress',
  'IPR Pause',
  'Delivered',
  'Pause',
  'Req Time Estimate',
  'IPR Todo'
]
export const stageStatuslist: string[] = [
  'On Hold',
  'Draft',
  'IPR In Progress',
  'Req Time Estimate',
  'Req Time Estimate In Progress',
  'Pause',
  'IPR Pause',
  'In Progress',
  'IPR Ready To Deliver',
  'Internal Review',
  'Todo Per Review',
  'Final Review',
  'Ready To Deliver',
  'Delivered',
  'IPR Todo'
]
export const statusColors = {
  'On Hold': '#FF5733',
  'Draft': '#FFC300',
  'IPR': '#28A745',
  'IPR Todo': '#0ab631',
  'IPR In Progress': '#6BA779',
  'IPR Pause': '#256133',
  'IPR Delivered': '#31C950',
  'Req Time Estimate': '#17A2B8',
  'Req Time Estimate In Progress': '#4EAAB8',
  'Pause': '#B39DDB',
  'In Progress': '#098A07',
  'Peer Review In Progress': '#9B59B6',
  'IPR Ready To Deliver': '#2ECC71',
  'Internal Review': '#3498DB',
  'Internal Review In Progress': '#1E90FF',
  'Internal Review Pause': '#1d7aa5',
  'Todo Per Review': '#E67E22',
  'Todo Per Review In Progress': '#E68734',
  'Todo Per Review Pause': '#DC7D2A',
  'Final Review': '#F39C12',
  'Final Review Pause': '#f37712',
  'Final Review In Progress': '#F4AA33',
  'Ready To Deliver': '#1ABC9C',
  'Delivered': '#D35400',
}

export const teamData = [
  {
    teamName: "Team Name",
    projectName: "Project X",
    members: [
      { src: "https://via.placeholder.com/30", alt: "Member 1" },
      { src: "https://via.placeholder.com/30", alt: "Member 2" },
      { src: "https://via.placeholder.com/30", alt: "Member 3" }
    ]
  },
  {
    teamName: "Team Name",
    projectName: "Project Y",
    members: [
      { src: "https://via.placeholder.com/30", alt: "Member A" },
      { src: "https://via.placeholder.com/30", alt: "Member B" },
      { src: "https://via.placeholder.com/30", alt: "Member C" }
    ]
  },
  {
    teamName: "Team Name",
    projectName: "Project Y",
    members: [
      { src: "https://via.placeholder.com/30", alt: "Member A" },
      { src: "https://via.placeholder.com/30", alt: "Member B" },
      { src: "https://via.placeholder.com/30", alt: "Member C" }
    ]
  },
  {
    teamName: "Team Name",
    projectName: "Project Y",
    members: [
      { src: "https://via.placeholder.com/30", alt: "Member A" },
      { src: "https://via.placeholder.com/30", alt: "Member B" },
      { src: "https://via.placeholder.com/30", alt: "Member C" }
    ]
  },
];

export const teamDetails = [
  {
    teamName: "Team Alpha",
    projectName: "Project A",
    tasksCompleted: "Project name",
    yearsAtCompany: "4.5 years",
    workPending: "12,000 Hrs",
    workCompleted: "20,000 Hrs",
    rating: 4.2,
    ratingCount: 750,
    avatars: [
      "https://via.placeholder.com/30",
      "https://via.placeholder.com/30",
      "https://via.placeholder.com/30"
    ]
  },
  {
    teamName: "Team Beta",
    projectName: "Project B",
    tasksCompleted: "Project name",
    yearsAtCompany: "4.5 years",
    workPending: "12,000 Hrs",
    workCompleted: "20,000 Hrs",
    rating: 4.2,
    ratingCount: 750,
    avatars: [
      "https://via.placeholder.com/30",
      "https://via.placeholder.com/30",
      "https://via.placeholder.com/30"
    ]
  },
];
export const members = [
  { name: "Adela Parkson", projectName: "Active project name", imageUrl: "/api/placeholder/40/40" },
  { name: "Leighton Kramer", projectName: "Active project name", imageUrl: "/api/placeholder/40/40" },
  { name: "Jaylen Blackwell", projectName: "Active project name", imageUrl: "/api/placeholder/40/40" },
];

export const badgesData = [
  {
    "title": "Initial time estimate",
    "progress": 0,
    "level": "Gold Level",
    "icon": '',
    "background": '#E668AF',
    "badges": [BlankSilver, BlankBronze, BlankBronze]
  },
  {
    "title": "Time at company",
    "progress": 0,
    "level": "Silver Level",
    "background": '#60B680',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  },
  {
    "title": "Hours spent on project",
    "progress": 0,
    "level": " Bronze Level",
    "background": '#F8BB71',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  },
  {
    "title": "Rating consistency",
    "progress": 0,
    "level": "Bronze Level",
    "background": '#EBD737',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  },
  {
    "title": "Todo task completed",
    "progress": 0,
    "level": "Gold Level",
    "background": '#7AC555',
    "badges": [BlankGold, BlankSilver, BlankBronze]
  },
  {
    "title": "Review consistency count",
    "progress": 0,
    "level": "Bronze Level",
    "background": '#4A3671',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  },
  {
    "title": "Project created count",
    "progress": 0,
    "level": "Gold Level",
    "background": '#A1BE7F',
    "badges": [BlankSilver, BlankBronze, BlankGold]
  },
  {
    "title": "Project delivered count",
    "progress": 0,
    "level": "Silver Level",
    "background": '#48D37B',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  },
  {
    "title": "Project setup count",
    "progress": 0,
    "level": "Bronze Level",
    "background": '#7A96D3',
    "badges": [BlankGold, BlankSilver, BlankBronze]
  },
  {
    "title": "Background change count",
    "progress": 0,
    "level": "Silver Level",
    "background": '#B0B6BF',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  },
  {
    "title": "Rating given to others",
    "progress": 0,
    "level": "Silver Level",
    "background": '#E3B759',
    "badges": [BlankBronze, BlankSilver, BlankGold]
  }
];

export const getStageBadgeStyle = (stage: string) => {
  const s = (stage || '').toUpperCase();
  let color = '#EAB308';
  if (s.includes('PREL')) color = '#EAB308';
  else if (s.includes('IPR')) color = '#06B6D4';
  else if (s.includes('FULL')) color = '#22C55E';
  else if (s.includes('FIRE') || s.includes('SPRINKLER')) color = '#06B6D4';
  else if (s.includes('REV')) color = '#A855F7';
  else if (s.includes('PC')) color = '#3B82F6';

  return {
    bg: 'transparent',
    color: color,
    border: color,
  };
};

export const getStatusBadgeStyle = (status: string, waitingForPayment?: boolean) => {
  const normStatus = String(status || '').toLowerCase().trim();
  if (normStatus === 'ready to deliver' || normStatus === 'ipr ready to deliver' || normStatus.includes('ready to deliver')) {
    const isGreen = Boolean(waitingForPayment);
    return isGreen
      ? {
          bg: '#E6F4EA',
          color: '#16A34A',
          border: '#16A34A',
        }
      : {
          bg: '#FCE8E6',
          color: '#DC2626',
          border: '#DC2626',
        };
  }
  const color = (statusColors as any)[status] || '#17A2B8';
  return {
    bg: color,
    color: '#FFFFFF',
    border: color,
  };
};

export const getPriorityStyle = (priority: string) => {
  switch (priority) {
    case 'High':
      return { bg: '#FEE2E2', color: '#DC2626' };
    case 'Medium':
      return { bg: '#FFEDD5', color: '#D97706' };
    case 'Low':
      return { bg: '#E0F2FE', color: '#0284C7' };
    default:
      return { bg: '#F3F4F6', color: '#4B5563' };
  }
};

export const getTradeBadgeStyle = (trade: 'M' | 'E' | 'P' | 'S' | string) => {
  switch (trade) {
    case 'M':
      return { bg: '#FCE7F3', color: '#DB2777' };
    case 'E':
      return { bg: '#FEF3C7', color: '#D97706' };
    case 'P':
      return { bg: '#E0F2FE', color: '#0284C7' };
    case 'S':
      return { bg: '#F3E8FF', color: '#9333EA' };
    default:
      return { bg: '#F3F4F6', color: '#4B5563' };
  }
};

export const priorityOptions: { label: string; value: string }[] = [
  { label: 'Low', value: 'Low' },
  { label: 'Medium', value: 'Medium' },
  { label: 'High', value: 'High' },
];